import type {
  LoginInput,
  RegisterInput,
  RegisterResponse,
  SessionResponse,
} from '@mentorivo/shared';

import { api } from '@/lib/api';

/**
 * Oturum — artık gerçek.
 *
 * ---------------------------------------------------------------------------
 * Jetonu neden burada tutmuyoruz
 * ---------------------------------------------------------------------------
 * Access ve refresh jetonları API tarafından `HttpOnly` çerez olarak yazılıyor;
 * bu dosya onları GÖREMİYOR ve görmemeli. Sayfaya sızan tek bir script'in
 * `localStorage`'dan jeton okuyabilmesi, XSS'i oturum çalmaya çeviriyor.
 *
 * Bunun bedeli: "giriş yapmış mıyım" sorusunu istemci tarafında çerez okuyarak
 * cevaplayamıyoruz. İki yerde çözülüyor:
 *   1. Rota koruması `src/proxy.ts` içinde — sunucuda çalışıyor, HttpOnly
 *      çerezi görebiliyor.
 *   2. Arayüzün ihtiyacı olan kullanıcı bilgisi `getSession()` ile alınıyor.
 *
 * ---------------------------------------------------------------------------
 * Etkin workspace çerezi
 * ---------------------------------------------------------------------------
 * `mentorivo_ws` bilerek HttpOnly DEĞİL: hangi kiracının açık olduğu gizli bir
 * bilgi değil ve switcher'ın ilk boyamada seçili kalemi göstermesi gerekiyor.
 */

export const WORKSPACE_COOKIE = 'mentorivo_ws';

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match?.[1] ? decodeURIComponent(match[1]) : null;
}

/** Tarayıcının bildiği etkin workspace. Doğrulama sunucuda yapılıyor. */
export function activeWorkspaceId(): string | null {
  return readCookie(WORKSPACE_COOKIE);
}

export function signIn(input: LoginInput): Promise<SessionResponse> {
  return api.post<SessionResponse>('/auth/login', input);
}

export function signUp(input: RegisterInput): Promise<RegisterResponse> {
  return api.post<RegisterResponse>('/auth/register', input);
}

export function getSession(): Promise<SessionResponse> {
  return api.get<SessionResponse>('/auth/session');
}

/**
 * Çıkış. Hata yutuluyor: jeton zaten ölmüşse API 4xx dönebilir ama
 * kullanıcının niyeti belli — çerezler her hâlükârda temizlenmeli ve
 * arayüz giriş sayfasına gitmeli.
 */
export async function signOut(): Promise<void> {
  await api.post('/auth/logout').catch(() => undefined);
}

export function forgotPassword(email: string): Promise<void> {
  return api.post('/auth/forgot-password', { email });
}

export function resetPassword(token: string, password: string): Promise<void> {
  return api.post('/auth/reset-password', { token, password });
}

export function verifyEmail(token: string): Promise<void> {
  return api.post('/auth/verify-email', { token });
}

export function resendVerification(email: string): Promise<{ sent: boolean }> {
  return api.post<{ sent: boolean }>('/auth/resend-verification', { email });
}
